class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    if ($("#FacetsWrapperDesktop .js-range-slider").length > 0) {
      function prettify(ts) {
        return ts;
      }
      $("#FacetsWrapperDesktop .js-range-slider").ionRangeSlider({
        prettify: prettify,
        onFinish: function (data) {
          var fromPrice = parseFloat(data.from);
          var toPrice = parseFloat(data.to);
          $('.range-min').val(fromPrice);
          $('.range-max').val(toPrice);
          var rangeInput = document.querySelectorAll(".range-slider input");
          if (rangeInput) {
            document.querySelector(".range-slider input").dispatchEvent(new Event('change'));
            document.querySelector(".range-slider input").addEventListener("change", (event) => {
              var FacetFiltersFormNew = new FacetFiltersForm();
              FacetFiltersFormNew.onSubmitHandler(event);
            });
          }
        }
      });
    }

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        $(".btn-filter-product").unbind("click");
        $(".btn-filter-product").click(function(){
            $("body").addClass("show-product-sidebar");
        });
        $(".btn-close-sidebar-filter").unbind("click");
        $(".btn-close-sidebar-filter").click(function(){
            $("body").removeClass("show-product-sidebar");
        });
        var allRadios = document.querySelectorAll('form input[type=radio]');
        if(allRadios)
        {
          allRadios.forEach((element) => {
            element.addEventListener('change',(event) => {
              var FacetFiltersFormNew = new FacetFiltersForm();
              FacetFiltersFormNew.onSubmitHandler(event);
            });
          });  
        }
        document.querySelector(".range-slider input").addEventListener("change", (event) => {
          var FacetFiltersFormNew = new FacetFiltersForm();
          FacetFiltersFormNew.onSubmitHandler(event);  
        });
        function getListValue() { 
          var selectedOption, st;
          selectedOption = document.getElementById("SortBy").selectedIndex;
          st=document.getElementById("SortBy").options[selectedOption].value

           // window.location = st;
          //document.getElementById("myTextBoxResult").value=st;
          }

          function collectionTags() {
          var selectedOption, col;
          selectedOption = document.getElementById("pro-filter").selectedIndex;
          col=document.getElementById("pro-filter").options[selectedOption].value

           window.location = col;
          //document.getElementById("myTextBoxResult").value=st;
          }

           


          var x, i, j, l, ll, selElmnt, a, b, c,d;
          /*look for any elements with the class "custom-select":*/
          x = document.getElementsByClassName("custom-select");

          l = x.length;
          for (i = 0; i < l; i++) {
            
            selElmnt = x[i].getElementsByTagName("select")[0];
            ll = selElmnt.length;
            /*for each element, create a new DIV that will act as the selected item:*/
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            x[i].appendChild(a);
            /*for each element, create a new DIV that will contain the option list:*/
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide select" + i);
            for (j = 1; j < ll; j++) {
              /*for each option in the original select element,
              create a new DIV that will act as an option item:*/
              c = document.createElement("DIV");
              c.innerHTML = selElmnt.options[j].innerHTML;
              c.addEventListener("click", function(e) {
             
                  /*when an item is clicked, update the original select box,
                  and the selected item:*/
                  var y, i, k, s, h, sl, yl;
                  s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                  sl = s.length;
                  h = this.parentNode.previousSibling;
                  for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                      s.selectedIndex = i;
                      h.innerHTML = this.innerHTML;
                      
                      y = this.parentNode.getElementsByClassName("same-as-selected");
                      yl = y.length;
                      for (k = 0; k < yl; k++) {
                        y[k].removeAttribute("class");
                      }
                      this.setAttribute("class", "same-as-selected");
                      s.dispatchEvent(new Event('change'));
                      break;
                    }
                  }
                  h.click();
               
                // getListValue();
                // collectionTags();
                 
              });
              b.appendChild(c);
            }
            x[i].appendChild(b);
            a.addEventListener("click", function(e) {
                /*when the select box is clicked, close any other select boxes,
                and open/close the current select box:*/
                e.stopPropagation();
                closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
              
              });
           
          }
          function closeAllSelect(elmnt) {
            /*a function that will close all select boxes in the document,
            except the current select box:*/
            var x, y, i, xl, yl, arrNo = [];
            x = document.getElementsByClassName("select-items");
            y = document.getElementsByClassName("select-selected");
            xl = x.length;
            yl = y.length;
            for (i = 0; i < yl; i++) {
              if (elmnt == y[i]) {
                arrNo.push(i)
              } else {
                y[i].classList.remove("select-arrow-active");
              }
            }
            for (i = 0; i < xl; i++) {
              if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
              }
            }
          }

             
          /*if the user clicks anywhere outside the select box,
          then close all select boxes:*/
          document.addEventListener("click", closeAllSelect);



          var sortDrop = document.getElementsByClassName("select1");
          function displayDate() {
           var selectedOption, col;
          selectedOption = document.getElementById("pro-filter").selectedIndex;
          col=document.getElementById("pro-filter").options[selectedOption].value
            
            window.location = col;
             
          }
          for (var i = 0; i < sortDrop.length; i++) {
              sortDrop[i].addEventListener('click', displayDate, false);
          }


          document.querySelector("#SortBy").addEventListener('change',(event) => {
            var FacetFiltersFormNew = new FacetFiltersForm();
            FacetFiltersFormNew.onSubmitHandler(event);
          });

          document.querySelector("#SortBy-mobile").addEventListener('change',(event) => {
            var FacetFiltersFormNew = new FacetFiltersForm();
            FacetFiltersFormNew.onSubmitHandler(event);
          });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    $(".btn-filter-product").unbind("click");
    $(".btn-filter-product").click(function(){
        $("body").addClass("show-product-sidebar");
    });
    $(".btn-close-sidebar-filter").unbind("click");
    $(".btn-close-sidebar-filter").click(function(){
        $("body").removeClass("show-product-sidebar");
    });
    var allRadios = document.querySelectorAll('form input[type=radio]');
    if(allRadios)
    {
      allRadios.forEach((element) => {
        element.addEventListener('change',(event) => {
          var FacetFiltersFormNew = new FacetFiltersForm();
          FacetFiltersFormNew.onSubmitHandler(event);
        });
      });  
    }
    document.querySelector(".range-slider input").addEventListener("change", (event) => {
      var FacetFiltersFormNew = new FacetFiltersForm();
      FacetFiltersFormNew.onSubmitHandler(event);  
    });
    function getListValue() { 
      var selectedOption, st;
      selectedOption = document.getElementById("SortBy").selectedIndex;
      st=document.getElementById("SortBy").options[selectedOption].value

       // window.location = st;
      //document.getElementById("myTextBoxResult").value=st;
      }

      function collectionTags() {
      var selectedOption, col;
      selectedOption = document.getElementById("pro-filter").selectedIndex;
      col=document.getElementById("pro-filter").options[selectedOption].value

       window.location = col;
      //document.getElementById("myTextBoxResult").value=st;
      }

       


      var x, i, j, l, ll, selElmnt, a, b, c,d;
      /*look for any elements with the class "custom-select":*/
      x = document.getElementsByClassName("custom-select");

      l = x.length;
      for (i = 0; i < l; i++) {
        
        selElmnt = x[i].getElementsByTagName("select")[0];
        ll = selElmnt.length;
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide select" + i);
        for (j = 1; j < ll; j++) {
          /*for each option in the original select element,
          create a new DIV that will act as an option item:*/
          c = document.createElement("DIV");
          c.innerHTML = selElmnt.options[j].innerHTML;
          c.addEventListener("click", function(e) {
         
              /*when an item is clicked, update the original select box,
              and the selected item:*/
              var y, i, k, s, h, sl, yl;
              s = this.parentNode.parentNode.getElementsByTagName("select")[0];
              sl = s.length;
              h = this.parentNode.previousSibling;
              for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                  s.selectedIndex = i;
                  h.innerHTML = this.innerHTML;
                  
                  y = this.parentNode.getElementsByClassName("same-as-selected");
                  yl = y.length;
                  for (k = 0; k < yl; k++) {
                    y[k].removeAttribute("class");
                  }
                  this.setAttribute("class", "same-as-selected");
                  s.dispatchEvent(new Event('change'));
                  break;
                }
              }
              h.click();
           
            // getListValue();
            // collectionTags();
             
          });
          b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
            /*when the select box is clicked, close any other select boxes,
            and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
          
          });
       
      }
      function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
        except the current select box:*/
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i)
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }

         
      /*if the user clicks anywhere outside the select box,
      then close all select boxes:*/
      document.addEventListener("click", closeAllSelect);



      var sortDrop = document.getElementsByClassName("select1");
      function displayDate() {
       var selectedOption, col;
      selectedOption = document.getElementById("pro-filter").selectedIndex;
      col=document.getElementById("pro-filter").options[selectedOption].value
        
        window.location = col;
         
      }
      for (var i = 0; i < sortDrop.length; i++) {
          sortDrop[i].addEventListener('click', displayDate, false);
      }


      document.querySelector("#SortBy").addEventListener('change',(event) => {
        var FacetFiltersFormNew = new FacetFiltersForm();
        FacetFiltersFormNew.onSubmitHandler(event);
      });

      document.querySelector("#SortBy-mobile").addEventListener('change',(event) => {
        var FacetFiltersFormNew = new FacetFiltersForm();
        FacetFiltersFormNew.onSubmitHandler(event);
      });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    // const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if(container)
    {
      container.innerHTML = count;
      container.classList.remove('loading');  
    }
    
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') 
    {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } 
    else 
    {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
